import script from "./FeeDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./FeeDialog.vue?vue&type=script&lang=ts&setup=true"

import "./FeeDialog.vue?vue&type=style&index=0&id=63578d28&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63578d28"]])

export default __exports__